import { Button4 } from "@/Components/Buttons";
import { Button } from "@/shadcnComponents/ui/button";

interface LiveCampaignAddFundsProps {
  addFundsAmount: number;
  setAddFundsAmount: React.Dispatch<React.SetStateAction<number>>;
  handleAddFunds: () => void;
  addFundsAmountGst: number;
}

export const LiveCampaignAddFunds = ({
  addFundsAmount,
  setAddFundsAmount,
  handleAddFunds,
  addFundsAmountGst,
}: LiveCampaignAddFundsProps) => {
  return (
    <div className=" text-[#424242] flex flex-col w-full h-screen items-center justify-center ">
      <p className="text-[40px] font-bold text-[#424242] ">Add Funds</p>
      <p className="text-center text-[14px] font-[400]">
        Your campaign seems to be taking off! <br /> More funds are needed to
        continue this campaign
      </p>
      <div className="flex flex-col px-[40px] py-[20px] mt-[20px] items-center gap-[20px] rounded-[8px] border-[1px] border-solid border-[#E0E0E0]">
        <p>Select the amount you want to recharge</p>
        <div className="flex gap-[20px]">
          <Button4
            onClick={() => {
              setAddFundsAmount(12000);
            }}
            text="₹12000"
            icon={undefined}
            rightIcon={undefined}
            background={addFundsAmount === 12000 ? "#121212" : ""}
            textColor={addFundsAmount === 12000 ? "#FAFAFA" : ""}
            borderColor={undefined}
          />
          <Button4
            onClick={() => {
              setAddFundsAmount(15000);
            }}
            text="₹15000"
            icon={undefined}
            rightIcon={undefined}
            background={addFundsAmount === 15000 ? "#121212" : ""}
            textColor={addFundsAmount === 15000 ? "#FAFAFA" : ""}
            borderColor={undefined}
          />

          <input
            className="justify-center w-[100px] items-center px-[10px] py-[0px] flex gap-[8px] rounded-[198px] bg-transparent border-[1px] border-[#75757560]"
            type="Number"
            placeholder="custom"
            min={0}
            value={addFundsAmount}
            onChange={(event) =>
              setAddFundsAmount(parseInt(event.target.value))
            }
          />
        </div>
        <p className="text-[#757575] font-[700] text-[16px] ">Order Summary</p>
        <div className="flex">
          <p className="w-[136px]">{`Amount to be added`}</p>
          <p className="w-[40px]">:</p>
          <p>
            <b>{`₹ ${addFundsAmount || 0}`}</b>
          </p>
        </div>
        <div className="flex">
          <p className="w-[136px]">{`GST ( 18% )`}</p>
          <p className="w-[40px]">:</p>
          <p>
            <b>{`₹ ${addFundsAmountGst || 0}`}</b>
          </p>
        </div>
        <div className="flex">
          <p className="w-[136px]">{`Total Amount`}</p>
          <p className="w-[40px]">:</p>
          <p>
            <b>{`₹ ${addFundsAmount + addFundsAmountGst || 0}`}</b>
          </p>
        </div>
        <Button onClick={handleAddFunds}>
          CONTINUE TO PAY ₹{addFundsAmount + addFundsAmountGst || 0}
        </Button>
      </div>
    </div>
  );
};
